import { useEffect, useMemo, useState } from 'react';
import { fetchProducts, Product } from '@/lib/api';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProductCard from './components/ProductCard';

export default function ProductsPage() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState('newest');

  useEffect(() => {
    fetchProducts()
      .then(data => setProducts(data.filter(p => p.published)))
      .finally(() => setLoading(false));
  }, []);

  const sortedProducts = useMemo(() => {
    const sorted = [...products];
    if (sortBy === 'price_asc') {
      sorted.sort((a, b) => a.price - b.price);
    } else if (sortBy === 'price_desc') {
      sorted.sort((a, b) => b.price - a.price);
    }
    return sorted;
  }, [products, sortBy]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="bg-secondary-50 py-16 px-6 text-center">
          <p className="text-xs tracking-[0.3em] text-primary-500 mb-3 uppercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            Products
          </p>
          <h1 className="text-4xl md:text-6xl font-light text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            All Goods
          </h1>
        </div>

        <div className="max-w-7xl mx-auto px-6 py-12" data-product-shop>
          <div className="flex items-center justify-end gap-5 mb-10">
            <select
              value={sortBy}
              onChange={e => setSortBy(e.target.value)}
              className="text-sm text-foreground-700 bg-background-100 border border-background-200 px-4 py-2 outline-none cursor-pointer rounded-full"
              style={{ fontFamily: "var(--font-body)" }}
            >
              <option value="newest">新着順</option>
              <option value="price_asc">価格が低い順</option>
              <option value="price_desc">価格が高い順</option>
            </select>
          </div>

          {loading ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="animate-pulse">
                  <div className="bg-background-100 aspect-[3/4] rounded-xl mb-4"></div>
                  <div className="h-3 bg-background-100 rounded mb-2 w-1/2"></div>
                  <div className="h-4 bg-background-100 rounded mb-2"></div>
                  <div className="h-3 bg-background-100 rounded w-1/3"></div>
                </div>
              ))}
            </div>
          ) : sortedProducts.length === 0 ? (
            <div className="text-center py-24">
              <p className="text-foreground-500 text-base" style={{ fontFamily: "var(--font-body)" }}>
                商品が見つかりませんでした
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {sortedProducts.map(product => (
                <ProductCard key={product.slug} product={product} />
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
